// Define the SlideNumber extension
function SlideNumber(Splide, Components) {
    const { root } = Components.Elements;
    let elm;
    
    function mount() {
      elm = document.createElement('div');
      elm.className = 'splide__slide-number';
      elm.style.position = 'absolute';
      elm.style.bottom = '10px';
      elm.style.left = '10px';
      elm.style.backgroundColor = 'rgba(0,0,0,0.5)';
      elm.style.color = 'white';
      elm.style.padding = '5px 10px';
      elm.style.borderRadius = '5px';
      elm.style.fontSize = '14px';
      root.appendChild(elm);
      update();
      Splide.on('moved', update);
    }
    
    function update() {
      elm.textContent = `${Splide.index + 1}/${Splide.length}`;
    }
    
    return {
      mount,
      destroy() {
        if (elm && elm.parentNode) {
          elm.parentNode.removeChild(elm);
        }
      },
    };
  }
  
  // Function to initialize sliders
  function initializeSliders() {
    var main = new Splide('#main-slider', {
      type      : 'slide',
      rewind    : false,
      pagination: false,
      arrows    : false,
      breakpoints : {
        1024: {
          
        },
        768: {
          padding: { right: '5rem' },
        }
      },
    });
  
    var thumbnails = new Splide('#thumbnail-slider', {
      fixedWidth  : 191,
      fixedHeight : 254,
      height: 746,
      gap         : 10,
      rewind      : false,
      pagination  : false,
      cover       : true,
      isNavigation: true,
      direction: 'ttb',
      breakpoints : {
        1024: {
          direction: 'ltr',
        },
        768: {
          destroy: true,
        }
      },
    });
  
    // Function to pause all Wistia videos
    function pauseAllWistiaVideos() {
      var wistiaEmbeds = document.querySelectorAll('#main-slider .wistia_embed');
      wistiaEmbeds.forEach(function (wistiaEmbed) {
        var api = Wistia.api(wistiaEmbed);
        if (api) {
          api.pause();
        }
      });
    }
  
    // Function to play Wistia video in active slide
    function playActiveSlideVideo() {
      var activeIndex = main.index;
      var slides = main.Components.Elements.slides;
      var activeSlide = slides[activeIndex];
      var wistiaEmbed = activeSlide.querySelector('#main-slider .wistia_embed');
  
      if (wistiaEmbed) {
        var api = Wistia.api(wistiaEmbed);
        if (api) {
          api.play();
        }
      }
    }
  
    // Add event listeners for video control
    main.on('move', pauseAllWistiaVideos);
    main.on('moved', playActiveSlideVideo);
  
    // Mount both sliders
    main.mount();
    thumbnails.mount();
  
    // Sync the sliders
    main.sync(thumbnails);
  
    // Add the SlideNumber extension to the main slider
    var slideNumberExtension = new SlideNumber(main, main.Components);
    slideNumberExtension.mount();
  
    // Optionally, you can add an event listener to destroy the extension if needed
    main.on('destroy', function() {
      slideNumberExtension.destroy();
    });
  }
  
  // Add event listeners
  document.addEventListener('DOMContentLoaded', initializeSliders);
  document.addEventListener('shopify:section:load', initializeSliders);